export interface SiteLink {
  id: number;
  name: string;
  url: string;
  icon: string;
}

export interface LinkCategory {
  id: number;
  title: string;
  links: SiteLink[];
}

export const linkCategories: LinkCategory[] = [
  {
    id: 1,
    title: 'Vikings Fan Sites',
    links: [
      { id: 1, name: 'Daily Norseman', url: 'https://www.dailynorseman.com', icon: 'ri-football-line' },
      { id: 2, name: 'KAB Vikings', url: 'https://www.kabvikings.com', icon: 'ri-football-line' },
      { id: 3, name: 'Vikings Football Home', url: 'https://www.vikingsfootballhome.com', icon: 'ri-football-line' },
      { id: 4, name: 'Vikings Football Blog', url: 'https://www.vikingsfootballblog.com', icon: 'ri-football-line' },
      { id: 5, name: 'Purple Reign Vikings', url: 'https://www.purplereign.com', icon: 'ri-football-line' },
      { id: 6, name: 'Skol Nation', url: 'https://www.skolnation.com', icon: 'ri-football-line' },
    ],
  },
  {
    id: 2,
    title: 'Vikings Media Links',
    links: [
      { id: 7, name: 'CBS Sports Vikings', url: 'https://www.cbssports.com/nfl/teams/MIN/minnesota-vikings/', icon: 'ri-tv-line' },
      { id: 8, name: 'Vikings Sporting News', url: 'https://www.sportingnews.com/us/nfl/minnesota-vikings', icon: 'ri-newspaper-line' },
      { id: 9, name: 'SI Vikings', url: 'https://www.si.com/nfl/vikings', icon: 'ri-newspaper-line' },
      { id: 10, name: 'ESPN Vikings Clubhouse', url: 'https://www.espn.com/nfl/team/_/name/min/minnesota-vikings', icon: 'ri-tv-line' },
      { id: 11, name: 'Yahoo! Pro Vikings', url: 'https://sports.yahoo.com/nfl/teams/min/', icon: 'ri-global-line' },
      { id: 12, name: 'KFAN', url: 'https://www.kfan.com', icon: 'ri-radio-line' },
      { id: 13, name: 'Vikes Centric', url: 'https://www.vikescentric.com', icon: 'ri-newspaper-line' },
    ],
  },
  {
    id: 3,
    title: 'NFL Reference / Stat Sites',
    links: [
      { id: 14, name: 'Pro Football Reference', url: 'https://www.pro-football-reference.com', icon: 'ri-bar-chart-line' },
      { id: 15, name: 'Pro Football Focus', url: 'https://www.pff.com', icon: 'ri-bar-chart-2-line' },
    ],
  },
  {
    id: 4,
    title: 'NFL Sites',
    links: [
      { id: 16, name: 'NFL', url: 'https://www.nfl.com', icon: 'ri-football-line' },
      { id: 17, name: 'NFL Network', url: 'https://www.nfl.com/network', icon: 'ri-tv-line' },
      { id: 18, name: 'St. Louis Rams', url: 'https://www.therams.com', icon: 'ri-football-line' },
    ],
  },
  {
    id: 5,
    title: 'National Media',
    links: [
      { id: 19, name: 'Pro Football Talk', url: 'https://profootballtalk.nbcsports.com', icon: 'ri-newspaper-line' },
      { id: 20, name: 'National Football Post', url: 'https://www.nationalfootballpost.com', icon: 'ri-newspaper-line' },
      { id: 21, name: 'ESPN', url: 'https://www.espn.com/nfl/', icon: 'ri-tv-line' },
      { id: 22, name: 'Fox Sports', url: 'https://www.foxsports.com/nfl', icon: 'ri-tv-line' },
      { id: 23, name: 'Yahoo Sports Shutdown Corner', url: 'https://sports.yahoo.com/nfl/', icon: 'ri-global-line' },
    ],
  },
];
